export const width = 210
export const height = (width / 210) * 297
export const getRelativeSizePt = (value: number, unit?: string) =>
  (value * width) / 210 + (unit ?? 'pt')
export const headingFontSize = getRelativeSizePt(12)
export const paragraphFontSize = getRelativeSizePt(11)
export const subLabelFontSize = getRelativeSizePt(10)
export const frontPageTitleFontSize = getRelativeSizePt(24)
export const frontPageHeadingFontSize = getRelativeSizePt(18)
